import { findIndex } from 'lodash';

//used in mutations NOT directly from actions
const updateModel = (state, model, listAction = 'append') => {
  const index = state.all.findIndex(({ id }) => id == model.id);

  if (index === -1) {
    if (listAction === 'prepend') {
      state.all.unshift(model);
    } else {
      state.all.push(model);
    }
  } else {
    state.all.splice(index, 1, model);
  }
};

export default {
  loading(state, flag = true) {
    state.loading = flag;
  },

  loaded(state, flag = true) {
    state.loaded = flag;
  },

  saving(state, flag = true) {
    state.saving = flag;
  },

  set(state, values = {}) {
    for (const key in values) {
      state[key] = values[key];
    }
  },

  setAll(state, records) {
    state.all = records;
  },

  setPagination(state, data) {
    state.page = data.page;
    state.pages = data.pages;
    state.count = data.count * 1;
  },

  setSome(state, { action = 'append', records = [] }) {
    records.forEach((r) => {
      updateModel(state, r, action);
    });
  },

  setOne(state, { action = 'append', record = {} }) {
    updateModel(state, record, action);
  },

  setSearch(state, search) {
    state.search = search;
  },

  setView(state, view) {
    state.view = view;
    localStorage.setItem(`${state.resource.path}View`, view);
  },

  update(state, { model, update, action = 'append' }) {
    let keys = Object.keys(update);

    if (keys.length) {
      keys.forEach((key) => {
        model[key] = update[key];
      });
    }

    updateModel(state, model, action);
  },

  delete(state, itemId) {
    state.all = state.all.filter((i) => i.id !== itemId);
  },
};
